module.exports = __webpack_public_path__ + "static/media/YM20_0.75be2d6f.jpg";